import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatInput } from "@angular/material/input";
import { ActivatedRoute, Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage } from "src/app/utils/local-storage";
import { CATEGORY } from "../report.constants";

@Component({
  selector: "app-report-detail",
  templateUrl: "./report-detail.component.html",
  styleUrls: ["./report-detail.component.scss"],
})
export class ReportDetailComponent implements OnInit {
  reportId: string;
  reportData: any;
  checkReportId = CATEGORY;
  radioOffice: string;
  fieldBranch: boolean;
  items: any;
  formReportDetail: FormGroup;
  loading: boolean = true;

  branch: string = "";
  branchType: string = "";
  buyer_type: string = "";
  notaxid = false;
  taxid = true;
  showbranch = false;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  formData: any;

  @ViewChild("branchName") nameInput: MatInput;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private builder: FormBuilder,
    private navController: NavController,
    private appService: AppService,
    private apiservice: ApiserviceService
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.initialCreateFomrReportDetail();
    this.route.queryParams.subscribe(async (params) => {

      if (Object.keys(params).length !== 0) {
        this.formData = params.formData
        const { reportId, items } = params;
        this.reportId = JSON.parse(reportId);
        this.items = JSON.parse(items);
        console.log('this.reportId=======: ', this.reportId)
        console.log('this.items=======: ', this.items)
        await this.getData();
        this.setFomrReportDetail(this.items.detail);
        this.radioOffice = this.items.branch_no;

      }
    });
  }

  ngOnInit() {
    if (this.radioOffice === "branch") {
      this.fieldBranch = true;
    } else {
      this.fieldBranch = false;
    }
    this.loading = true;
  }

  async getData() {
    this.loading = true;
    this.reportData = null;
    const url = `${this.apiservice.apiUrl}${this.apiservice.getTaxInvoiceDetail}`;
    const req = {
      taxinvoice_no:
        this.reportId == "002"
          ? this.items.creditnote_no
          : this.items.tax_invoice_no,
      userBu: this.items.bu,
      userLoc: this.items.loc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
      mtrans_id: this.items.mtrans_id
    };
    console.log("req", req);

    const res = await this.apiservice._post(url, req);
    this.loading = false;
    console.log("res...", res);
    if (res.result === "S") {

      this.reportData = res.data[0];
      if (this.reportData.buyer.name_info.type === "1") {
        this.showbranch = true;
        this.branchType = res.data[0].branch_no == "" || res.data[0].branch_no == "00000" ? "0" : "1";
        this.branch = res.data[0].branch_no == "" || res.data[0].branch_no == "00000" ? "" : res.data[0].branch_no;
      } else {
        this.showbranch = false
      }

      this.loading = false;

      console.log(
        "data report data .....",
        this.reportData.buyer.name_info.type
      );
      if (this.reportData.buyer.name_info.type === "3") {
        this.notaxid = false;
      } else {
        this.notaxid = true;
        this.buyer_type = this.reportData.buyer.name_info.type;
      }
      // this.reportData.buyer.name_info.type === "3"?this.notaxid = false:this.notaxid = true && this.buyer_type == this.reportData.buyer.name_info.type;
    } else {
      this.loading = false;
    }
  }

  initialCreateFomrReportDetail() {
    this.formReportDetail = this.builder.group({
      category: [{ value: "", disabled: true }],
      name: [{ value: "", disabled: true }],
      numberID: [{ value: "", disabled: true }],
      branchOrder: [{ value: "", disabled: true }],
    });
  }

  setFomrReportDetail(detail) {
    this.formReportDetail.patchValue({
      category: "category",
      name: "name",
      tax_invoice_no: "tax_invoice_no",
      branchOrder: "branchOrder",
    });
  }

  officeSetting(e) {
    if (e.detail.value === "branch") {
      this.fieldBranch = true;
      setTimeout(() => {
        this.nameInput.focus();
      }, 100);
    } else {
      this.fieldBranch = false;
    }
  }

  onBlackPage() {

    const navigationExtras = {
      queryParams: {
        formReport: this.formData,
      },
    };

    this.router.navigate(["report-document"], navigationExtras);
  }
  formatnumber(data) {
    return data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  number(data: any) {
    let number = data;
    return String(number).padStart(13, "0");
  }
}
